import { widgetAccountTrainCourse } from './WidgetAccountTrainCourses/WidgetAccountTrainCourses';
export const credentialingWidgets = [widgetAccountTrainCourse];
